import * as Yup from "yup";

export const validationSchema = Yup.object({
    name: Yup
        .string()
        .required("Required"),
    sex: Yup
        .string()
        .required("Required"),
    nation: Yup
        .string()
        .required("Required"),
    dob: Yup
        .string()
        .required("Required"),
    address: Yup
        .string()
        .required("Required"),
    identityNo: Yup
        .string()
        .required("Required"),
    department: Yup
        .string()
        .required("Required"),
    validityTime: Yup
        .string()
        .required("Required"),
    // imageBase64: Yup
    //     .string()
    //     .required("Required"),
})

export const initialValues = {
    name: "",
    sex: "",
    nation: "",
    dob: "",
    address: "",
    identityNo: "",
    department: "",
    validityTime: "",
    imageBase64: ""
}